<template>
    <div class='apply'>
        <div class="title" :class="$vuetify.theme.dark ? '': 'sub-title-l'">{{$t('preference.location.title')}}</div>
        <div id="location" style="flex: 1;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { reportLocation } from "@/api/index";
import monent from 'moment'
import store from '@/store'
export default {
    data() {
        return {

        };
    },
    props:{
        filterQuery:{
            type:Number,
            default:1
        }
    },
    watch:{
        filterQuery:{
            handler:function (val, oldVal) {
                this.initLocation()
            },
        }

    },
    mounted() {
        this.initLocation()
    },
    methods: {

        initLocation(){
            let startTime = monent().subtract(1,'w').startOf('days').unix()
            let endTime = monent().endOf('days').unix()
            // let endTime = monent().unix()
            if(this.filterQuery == 1){
                startTime = monent().subtract(6,'days').startOf('days').unix()
            }
            if(this.filterQuery == 2){
                startTime = monent().subtract(13,'days').startOf('days').unix()
            }
            if(this.filterQuery == 3){
                startTime = monent().subtract(20,'days').startOf('days').unix()
            }
            if(this.filterQuery == 4){
                startTime = monent().subtract(29,'days').startOf('days').unix()
            }
            if(this.filterQuery == 5){
                startTime = monent().subtract(59,'days').startOf('days').unix()
            }
            if(this.filterQuery == 6){
                startTime = monent().subtract(89,'days').startOf('days').unix()
            }

            let params = {
                startTime:startTime,
                endTime:endTime
            }
            reportLocation(params).then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    let list = []
                    let list2 = []
                    for (let item of res.data) {
                        list.push(item.name)
                        list2.push(item.value)
                    }
                    this.setEcharts(list, list2)
                }else{
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                }
            })
        },


        setEcharts(list, list2) {
            var chartDom = document.getElementById('location');
            var myChart = echarts.init(chartDom);
            var option = {
                grid: { containLabel: true },
                tooltip: {
                    trigger : 'axis',
                    formatter: '{b}: {c}('+this.$t('preference.num')+')'
                },
                xAxis: { show: false ,


                },
                yAxis: {
                    type: 'category',
                    axisLine: { show: false },
                    axisTick: { show: false },
                    splitLine: { show: false },
                    data: list,
                  axisLabel:{
                    color: this.$vuetify.theme.dark ? '#9994b0' : '#000'
                  },
                },
                series: [
                    {
                        type: 'bar',
                        data: list2,
                        barMaxWidth: 20,
                        label: {
                            show: true,
                            position: 'right',
                             color: this.$vuetify.theme.dark ? '#9994b0' : '#000',
                            valueAnimation: true
                        },
                        itemStyle: {
                            normal: {
                            color: function (colors) {
                                var colorList = [
                                    '#5066ed',
                                    '#02d7ff',
                                    '#00d48f',
                                    '#ff8c00',
                                    '#fa5c7c',
                                    '#ffc107',
                                    '#f5222d',
                                    '#a0d911',
                                    '#EC407A',
                                    '#8E24AA',
                                    '#673AB7',
                                    '#3F51B5',
                                    '#2196F3',
                                    '#4CAF50',
                                    '#CDDC39',
                                    '#FFEB3B',
                                    '#FFC107',
                                    '#FF9800',
                                    '#795548',
                                    '#607D8B',
                                ];
                                return colorList[colors.dataIndex];
                            }
                            },
                        }
                    }
                ]
            };
            option && myChart.setOption(option);
        }
    },
}
</script>

<style lang='scss' scoped>
.apply {
    height: 100%;
    display: flex;
    flex-direction: column;
    .title {
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-weight: 500;
        padding-left: 33px;
        border-bottom: 1px solid #F0F0F0;
    }
    .sub-title-l {
        color: #031b4e;
    }
}
</style>
